import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { HeaderService } from './services/header.service';



@NgModule({
  declarations: [
  ],
  imports: [
    SharedModule,
    RouterModule
  ],
  exports:[],
  providers: [HeaderService]
})
export class CoreModule { }
